"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Fieldset = _interopRequireDefault(require("./Fieldset"));

var _Legend = _interopRequireDefault(require("./Legend"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  margin-top: 16px;\n\n  &:after,\n  &:before {\n    content: '';\n    display: table;\n  }\n\n  &:after {\n    clear: both;\n  }\n\n  + p {\n    margin-top: 10px;\n  }\n\n  > *:last-child {\n    margin-bottom: 0;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var RadioWrapper = _styledComponents.default.div(_templateObject());

var RadioGroup = function RadioGroup(_ref) {
  var label = _ref.label,
      errorText = _ref.errorText,
      children = _ref.children;
  return /*#__PURE__*/_react.default.createElement(_Fieldset.default, null, /*#__PURE__*/_react.default.createElement(_Legend.default, {
    errorText: errorText
  }, label), /*#__PURE__*/_react.default.createElement(RadioWrapper, null, children));
};

RadioGroup.propTypes = {
  /** The legend text for the inputs */
  label: _propTypes.default.string,

  /** Used for validation */
  errorText: _propTypes.default.string,

  /** The grouped inputs */
  children: _propTypes.default.node.isRequired
};
RadioGroup.defaultProps = {
  label: '',
  errorText: ''
};
var _default = RadioGroup;
exports.default = _default;